<template>
    <!-- 下月必备·提前go 模块 -->
    <div class="scrambleCourseModule white_bg paddingV16" data-notice="下月必备 用提前购的数据">
        <div class="inner" style="padding: 0 18px;">

            <header class="header moduleHeader clearfix" style="padding-bottom: 17px;">
                <div class="floatL">
                    <div class="titleArea" :style="titleStyle">
                        {{title}}
                    </div>
                </div>
                <div class="fr alignRight">
                    <router-link class="button iconButton moreContentButton" :to="{name : 'nextMonthVodCoursePage'}"></router-link>
                </div>
            </header>

            <div class="body">

                <div class="inner">
                    <div :class="layout">
                        <div class="item" v-for="dataItem in dataList"
                             :key="dataItem.id" @click="viewItem(dataItem)">

                            <div class="imageArea marginB8 roundBorder8 hiddenOverflow">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                            </div>
                            <div class="titleArea hiddenOverflow font14r color333 bold marginB8">
                                {{dataItem.title}}
                            </div>
                            <div class="descArea clearfix f12">
                                <div class="fl orange">共{{dataItem.segCount}}节</div>
                                <div class="fr">共{{dataItem.applyCount}}人学</div>
                            </div>

                        </div>
                    </div><!-- end .list -->

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>
                </div><!-- end .inner -->

                <div class="font14r alignC" style="line-height: 34px; color: #B7B6B5;"
                     @click="loadNextPage()" v-show="status=='ready' && pagination.current < pagination.totalPage">点击加载更多&gt;
                </div>

                <div class="font14r grey999" v-if="status==='error'">数据加载失败</div>

            </div><!-- end .body -->
        </div>
    </div>
</template>

<script>
import modulePart from '@/components/part/modulePart';
import moment from 'moment';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/go/list',
            params : {},
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "scrambleCourseModule",
    extends : modulePart,
    props : {
        title : {
            type : String,
            default : ''
        },
        desc : {
            type : String,
            default : ''
        },
        layout : {
            type : String,
            default : 'horizontal3CardLayout'
        },
        viewAllText : {
            type : String,
            default : ''
        },
        itemCount : {
            type : Number,
            default : 3
        },
        dataParams : {
            type : Object,
            default : () => {
                return {}
            }
        },

    },
    data () {
        return {
            apiConfig: config.apiConfig
        }
    },
    methods : {
        viewItem : function (dataItem) {
            appHelper.redirect('/course/coursePrepay/' + dataItem.id)
        },
        formatDateYMD : function (timestamp) {
            return moment(timestamp).format('YYYY.MM.DD');
        },
        formatDateMD : function (timestamp) {
            return moment(timestamp).format('MM.DD');
        }
    },
    mounted() {
        this.pageSize = this.pagination.pageSize = this.itemCount;
        this.apiConfig.list.params = this.dataParams;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: hsla(36, 77%, 45%, 1);
}
.scrambleCourseModule {
    .table2ColumnCardLayout {
        /*padding-left: 10px;*/
        display: grid;
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        grid-template-columns: repeat(2, 1fr);

        .imageArea {
            height: 80px;
            overflow: hidden;
        }
        .titleArea {
            height: 3em;
            line-height: 1.5em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
        }
        .descArea {
            overflow: hidden;
        }
    }
}


.bookingButton {
    width: 82px;
    height: 32px;
    line-height: 32px;
    background: hsla(36, 100%, 57%, 1);
    border-radius: 16px;
    border: none 0;
    padding: 0;
}

.viewAll {
    height: 31px;
    line-height: 31px;
    background: rgba(255,255,255,.3);
    border: 1px solid #F55050;
    border-radius: 8px;
    overflow: hidden;
    text-align: center;
    color: #F55050;
    a, a:visited {
        color: #F55050;
    }
}
.redTextLabel {
    border: solid 1px hsla(0, 100%, 76%, 1);
    background: hsla(0, 100%, 98%, 1);
    height: 16px;
    line-height: 16px;
    box-sizing: border-box;
    color: hsla(0, 89%, 64%, 1);
    padding: 0 5px;
    font-size: 10px;
    font-weight: normal;
    border-radius: 2px;
}
</style>

